import React from "react";

import {cn} from "@isudio/utils";

interface GradientButtonProps extends React.ComponentProps<"button"> {
  type?: "button" | "submit" | "reset";
  text?: string;
  className?: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onEnter?: () => void;
}

export const GradientButton = ({
                                 type = "button",
                                 text = "Click",
                                 className,
                                 disabled = false,
                                 onClick,
                                 onEnter,
                                 ...props
                               }: GradientButtonProps) => {
  const _onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick(event);
  };

  const _onKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key !== "Enter") return;
    if (onEnter) onEnter();
  };

  return (
    <button
      type={type}
      className={
        cn(
          "btn relative flex cursor-pointer items-center justify-center overflow-hidden rounded-[100px] text-base border-none p-px focus:outline-none focus:ring-0 focus:border-transparent",
          (disabled ? 'opacity-50 cursor-not-allowed text-gray-lighter hover:text-inherit hover:scale-100' : 'cursor-pointer text-white hover:text-generic-hover hover:scale-105'),
          className
        )}
      disabled={disabled}
      onClick={_onClick}
      onKeyDown={_onKeyDown}
      {...props}
    >
      <span
        className="btnSpan relative z-1 w-full rounded-[100px] bg-bluegray-darker/80 p-2 backdrop-blur-2xl">
        {text}
      </span>
    </button>
  );
}